Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.OperatorStatusTypeView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/operator_status_type"]

  initialize: (options) ->
    @inputID = options.id
    @statusTypes = options.data
    @selectedType = options.selected
    @disabled = options.disabled
    super

  render: =>
    @$el.html @template(inputID: @inputID, statusTypes: @statusTypes, selectedType: @selectedType, selectedDisabled: @disabled)
    @

  setSelectedType: (selected) =>
    @selectedType = selected

  setSelectedDisabled: (state) =>
    @disabled = state

  hide: =>
    @$el.addClass('d-none')

  show: =>
    @$el.removeClass('d-none')
